export default __webpack_public_path__ + "static/media/chevron_down.cca8752f.svg";